const multipleFieldRegexp = /\[]$/

/**
 * Turns a FormData object into an Object.
 * Supports fields with multiple values.
 *
 * @param {FormData} formData
 * @returns {Object}
 */
export function formDataToObject(formData) {
  return Array.from(formData.entries()).reduce((values, [field, value]) => {
    let singleValue = multipleFieldRegexp.test(field) ? [value] : value
    values[field] = field in values ? [].concat(values[field], value) : singleValue

    return values
  }, {})
}
